import { configureStore, ThunkAction, UnknownAction } from '@reduxjs/toolkit';
import counterReducer from './features/counterSlice';
import empresa from './manager/empresa.reducer';
import grupoEmpresarial from './manager/grupo/grupo-empresarial.reducer';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import empresaServicio from './manager/empresa-servicio.reducer';
import contacto from './manager/contacto.reducer';
import proveedor from './manager/proveedor.reducer';
import authentication from './shared/authentication/reducers/authentication';
import workflowClase   from './manager/workflow-clase.reducer';
import workflowDef     from './manager/workflow-def.reducer';
import tipoActividad       from './manager/tipo-actividad.reducer';
import categoriaActividad  from './manager/categoria-actividad.reducer';
import usuario             from './manager/usuario.reducer';
import sysPerfil           from './manager/sys-perfil.reducer';
import sysTask             from './manager/sys-task.reducer';
import workflowEmpresa    from './manager/workflow-empresa.reducer';
import workflowDiseno         from './manager/workflow-diseno.reducer';
import workflowEmpresaDiseno  from './manager/workflow-empresa-diseno.reducer';
import workflowActividad          from './manager/workflow-actividad.reducer';
import workflowEmpresaActividad   from './manager/workflow-empresa-actividad.reducer';
import workflowInstancia          from './manager/workflow-instancia.reducer';
import workflowNodoInstancia      from './manager/workflow-nodo-instancia.reducer';
import workflowInstanciaEstadoNodos from './manager/workflow-instancia-estado-nodos.reducer';
import profaseUsuarioInbox from './manager/profase-usuario-inbox.reducer';


export const store = configureStore({
  reducer: {
    counter: counterReducer,
    grupoEmpresarial: grupoEmpresarial,
    empresa: empresa,
    empresaServicio: empresaServicio,
    contacto: contacto,
    proveedor: proveedor,
    authentication: authentication,
    workflowClase:  workflowClase,
    workflowDef:    workflowDef,
    tipoActividad:       tipoActividad,
    categoriaActividad:  categoriaActividad,
    usuario:             usuario,
    sysPerfil:           sysPerfil,
    sysTask:             sysTask,
    workflowEmpresa:     workflowEmpresa,
    workflowDiseno:          workflowDiseno,
    workflowEmpresaDiseno:   workflowEmpresaDiseno,
    workflowActividad:           workflowActividad,
    workflowEmpresaActividad:    workflowEmpresaActividad,
    workflowInstancia:           workflowInstancia,
    workflowNodoInstancia:       workflowNodoInstancia,
    workflowInstanciaEstadoNodos,
    profaseUsuarioInbox,
  },
});


export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export type IRootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<any, any, any, any>;

export const useAppSelector: TypedUseSelectorHook<any> = useSelector;
export const useAppDispatch = () => useDispatch<AppDispatch>();

const getStore = () => store;

export default getStore;

//----
